import { createRouter, createWebHistory } from "vue-router"
import AccueilPage from "./pages/AccueilPage.vue"
import LieuPage from "./pages/LieuPage.vue"
import ProgrammePage from "./pages/ProgrammePage.vue"
import DressCodePage from "./pages/DressCodePage.vue"
import LogementPage from "./pages/LogementPage.vue"
import InvitesPage from "./pages/InvitesPage.vue"
import ListeMariagePage from "./pages/ListeMariagePage.vue"
import FaqPage from "./pages/FaqPage.vue"

const routes = [
  { path: "/", name: "accueil", component: AccueilPage },
  { path: "/lieu", name: "lieu", component: LieuPage },
  { path: "/programme", name: "programme", component: ProgrammePage },
  { path: "/dresscode", name: "dresscode", component: DressCodePage },
  { path: "/logement", name: "logement", component: LogementPage },
  { path: "/invites", name: "invites", component: InvitesPage },
  { path: "/liste-de-mariage", name: "liste-de-mariage", component: ListeMariagePage },
  { path: "/faq", name: "faq", component: FaqPage },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0, behavior: "smooth" }
  },
})

export default router
